import { render, staticRenderFns } from "./CM2BrigthnessMeasurement.vue?vue&type=template&id=d5da98f6&"
import script from "./CM2BrigthnessMeasurement.vue?vue&type=script&lang=js&"
export * from "./CM2BrigthnessMeasurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports